import formMapper from 'forms/utils/formMapper';
import { documentIdAttachment } from 'forms/validations';

import { NAME } from './constants';

export default formMapper(NAME, {
	documentId: {
		required: false,
		validations: documentIdAttachment,
	},
});
